import React from "react";
import { motion } from "framer-motion";

export default function ImpastoSection() {
    return (
        <section className="relative bg-[#090D16] overflow-hidden py-24 px-6 border-t border-accent/10">
            {/* Sfondo d'atmosfera con gradiente profondo */}
            <div className="absolute inset-0 bg-gradient-to-tr from-black via-[#0D121F]/40 to-transparent pointer-events-none z-0" />
            <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-[100px] pointer-events-none" />

            {/* 🚀 LAYOUT ALTERNATO: lg:flex-row-reverse bilancia l'immagine a destra e il testo a sinistra */}
            <div className="relative max-w-5xl mx-auto z-10 flex flex-col lg:flex-row-reverse items-center gap-12 lg:gap-16">

                {/* Video Block Premium */}
                <motion.div
                    className="w-full lg:w-1/2 relative group"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-50px" }}
                    transition={{ duration: 0.7, ease: "easeOut" }}
                >
                    <div className="absolute -inset-2 rounded-[20px] border border-accent/10 pointer-events-none transition-all duration-500 group-hover:border-primary/20" />

                    <div className="aspect-video relative w-full rounded-2xl overflow-hidden shadow-2xl border border-accent/30 bg-black/20">
                        <video
                            muted
                            autoPlay
                            loop
                            playsInline
                            className="w-full h-full object-cover scale-[1.01] brightness-[1.02] transition-transform duration-700 group-hover:scale-105"
                        >
                            <source src="/videos/impasto.webm" type="video/webm" />
                            <source src="/videos/impasto.mp4" type="video/mp4" />
                        </video>
                        <div className="absolute inset-0 bg-black/10 group-hover:opacity-0 transition-opacity duration-500 pointer-events-none" />
                    </div>
                </motion.div>

                {/* Contenuto Testuale Ottimizzato */}
                <motion.div
                    className="w-full lg:w-1/2 text-left space-y-5"
                    initial={{ x: -30, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <div className="space-y-2">
                        <span className="text-primary text-xs font-black tracking-widest uppercase block">Il Laboratorio</span>
                        <h2 className="text-3xl md:text-4xl font-title text-secondary tracking-tight leading-tight">
                            L'Arte della Lenta Maturazione
                        </h2>
                    </div>

                    <div className="w-12 h-[2px] bg-primary/60 rounded-full" />

                    <div className="space-y-4 text-muted text-sm md:text-base leading-relaxed">
                        <p>
                            Il nostro impasto d'autore nasce da un'attenta selezione di farine di grano tenero <span className="text-secondary font-medium">Casillo</span>, arricchite con <span className="text-secondary font-medium">germe di grano vivo</span>. Questo prezioso dettaglio dona al cornicione un profilo aromatico intenso, rustico e autentico.
                        </p>
                        <p>
                            La vera magia avviene nel tempo: una maturazione controllata in cella per <span className="text-secondary font-bold">24 ore</span> permette lo sviluppo di una struttura molecolare perfetta. Spingiamo l'idratazione fino al <span className="text-primary font-black">70%</span>, integrando la massima quantità d'acqua per garantire una texture incredibilmente ariosa.
                        </p>
                        <p className="pt-2 text-secondary/90 font-medium flex items-start gap-2.5">
                            <span className="w-1.5 h-1.5 rounded-full bg-primary mt-[7px] shrink-0" />
                            <span>
                                Il risultato? Un morso fragrante dal cuore soffice, studiato per un'altissima digeribilità.
                            </span>
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}